
import { translate } from "react-i18next";
import * as React from "react";

import { Dublon } from "@wg/wows-react-uikit";

import { thousands } from "../../../helpers/formatting";

import styles from "./ErrorDublon.scss";

export type IProps = {
  caption: string;
  amount: number;
  deficit: number;
  t: (arg0: string, arg1: {deficit: (arg0: number) => number;}) => string;
};

const ErrorDublon = (props: IProps) => <div className={styles.error}>
        <div>
            <span className={styles.caption}>{props.caption}</span>
            <Dublon amount={props.amount} />
        </div>
        <div className={styles.message}>
            {props.t('Не хватает: %(deficit)s', { deficit: thousands(props.deficit) })}
        </div>
    </div>;

export default translate()(ErrorDublon);